import { useEffect, useRef } from "react";
import AdditionGroupsList from "./AdditionGroupsList";
import Helper from "../../../utils/Helper";
import useUserStore from "../../../stores/store";
import { Image } from "antd";

export default function InvoicePreview({ orderDetails, buttonRef }) {
  const contentRef = useRef(null);
  const { invoiceSettingsNameAndLogo } = useUserStore();

  console.log('================orderDetails==========', orderDetails);

  useEffect(() => {
    const timeout = setTimeout(() => {
      buttonRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }, 300); // Slight delay to wait for modal content

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="w-full h-auto my-[30px] bg-white bg-no-repeat rounded-[12px] opacity-100" ref={contentRef}>
      <div className="w-full h-full font-p_regular">
        {/* start of invoice no & date */}
        <div className="w-full flex flex-row items-center justify-end">
          <div className="w-auto h-full text-left text-[12px] leading-[18px] tracking-normal text-[#000000] opacity-100">
            Order No: {orderDetails?.orderNumber}
          </div>
        </div>

        <div className="w-full flex flex-row items-center justify-end">
          <div className="w-auto h-full text-left text-[12px] leading-[18px] tracking-normal text-[#000000] opacity-100">
            Date: {orderDetails?.orderDate}
          </div>
        </div>
        {/* end of invoice no & date */}

        {/* start table number */}
        {orderDetails?.tableNumber !== "" && (
          <div className="w-full h-[17px] flex flex-row items-center justify-end">
            <div className="w-auto h-full text-left text-[12px] leading-[18px] tracking-normal text-[#000000] opacity-100">
              Table {orderDetails?.tableNumber}
            </div>
          </div>
        )}
        {/* end table number */}

        {/* start restaurant name */}
        {invoiceSettingsNameAndLogo?.includes("LOGO") && orderDetails?.logo && (
          <div className="w-full  mt-[5px] flex flex-row items-center justify-center">
            <Image src={orderDetails.logo} width={150} height={150} />
          </div>
        )}

        {/* start restaurant name */}
        {invoiceSettingsNameAndLogo?.includes("NAME") && (
          <div className="w-full  mt-[5px] flex flex-row items-center justify-center">
            <div className="w-auto h-full text-center font-p_semibold text-[18px] leading-[35px] tracking-[0.72px] text-[#292929] opacity-100 break-words break-all whitespace-normal">
              {orderDetails?.restaurantName}
            </div>
          </div>
        )}
        {/* end restaurant name */}

        {/* start restaurant address */}
        <div className="w-full flex flex-row items-center justify-center">
          <div className="w-[272px] text-center font-p_medium text-[12px]  tracking-[0.6px] text-[#000000] uppercase opacity-100">
            {orderDetails?.restaurantAddress}
          </div>
        </div>
        {/* end restaurant address */}
        {/* start mobile number */}
        <div className="w-full flex flex-row items-center justify-center">
          <div className="w-[272px] h-full text-center font-p_medium text-[12px] tracking-[0.6px] text-[#000000] uppercase opacity-100">
            {orderDetails?.phoneNumber}
          </div>
        </div>
        {/* end mobile number */}
        {/* start restaurant web address */}
        <div className="w-full flex flex-row items-center justify-center">
          <div className="w-[272px] text-center font-p_medium text-[12px]  tracking-[0.6px] text-[#000000] uppercase opacity-100">
            {orderDetails?.webAddress}
          </div>
        </div>
        {/* end restaurant address */}
        {/* start restaurant social link */}
        <div className="w-full flex flex-row items-center justify-center">
          <div className="w-[272px] text-center font-p_medium text-[12px]  tracking-[0.6px] text-[#000000] uppercase opacity-100">
            {orderDetails?.socialLink}
          </div>
        </div>
        {/* end restaurant address */}

        {/* start bin number */}
        {orderDetails?.bin !== "" && (
          <div className="w-full flex flex-row items-center justify-center">
            <div className="w-[272px] text-center font-p_medium text-[12px] tracking-[0.6px] text-[#000000] uppercase opacity-100">
              BIN - {orderDetails?.bin}
            </div>
          </div>
        )}
        {/* end bin number */}

        {/* start mushak */}
        {orderDetails?.mushak !== "" && (
          <div className="w-full flex flex-row items-center justify-center">
            <div className="w-[272px] h-full text-center font-p_medium text-[12px] tracking-[0.6px] text-[#000000] uppercase opacity-100">
              Mushak - {orderDetails?.mushak}
            </div>
          </div>
        )}
        {/* end mushak */}

        <div className="w-full mt-[5px] border border-dashed border-[#e5e7eb]"></div>
        {orderDetails && orderDetails.isLoyaltyApplicable && (
          <>
            <div className="w-full mt-[5px] flex flex-row items-center justify-between gap-4 text-[14px] tracking-normal font-p_medium ">
              <div className="text-left text-[#341557] opacity-100 break-all">{orderDetails.customerInfo.name}</div>
              <div className="text-left text-[#341557] opacity-100">+{orderDetails.customerInfo.phoneNumber}</div>
            </div>
            <div className="w-full mt-[5px] flex flex-row items-center justify-between text-[14px] tracking-normal font-p_medium ">
              <div className="text-left text-[#341557] opacity-100">Loyalty Points</div>
              <div className="text-left text-[#341557] opacity-100">{orderDetails.loyaltyPointsBalance.toFixed(2)}</div>
            </div>
            <div className="w-full mt-[5px] border border-dashed border-[#e5e7eb]"></div>
          </>
        )}

        {/* start paid bill */}
        <div className="w-full flex flex-row items-center justify-center font-p_semibold text-[24px] tracking-[0.96px] text-[#292929]">
          {orderDetails?.paymentStatus === 1 ? "Paid" : "Guest"} Bill
        </div>
        {/* end paid bill */}

        <div className="w-full mt-[3px] border border-solid border-[#e5e7eb]"></div>

        {/* start item & prices */}
        <div className="w-full mt-[5px] flex flex-row items-center justify-between text-[14px] tracking-normal font-p_medium ">
          <div className="text-left text-[#341557] opacity-100">Item</div>
          <div className="text-left text-[#341557] opacity-100">Price</div>
        </div>

        <div className="w-full mt-[5px] mb-[5px] border border-solid border-[#e5e7eb]"></div>

        {orderDetails?.foods?.map((item, index) => (
          <div key={index + 999}>
            <div className="w-full h-auto flex flex-row items-center justify-between mb-1">
              <div className="flex-1 text-left font-bold text-[11px] leading-[17px] tracking-normal text-black opacity-100 break-all min-w-0">
                {item?.quantity ?? 0} x {item?.name ?? ""}
              </div>
              <div className="text-right font-bold text-[11px] leading-[17px] tracking-normal text-black opacity-100 whitespace-nowrap flex-shrink-0 pl-2">
                {(item?.quantity * item?.option?.price).toFixed(2)} TK
              </div>
            </div>

            {/* Add Ons List with Price */}
            {item.addOns.map((addOn, addOnIndex) => (
              <div key={addOnIndex} className="w-full h-auto flex flex-row items-center justify-between mb-1">
                <div className="flex-1 text-left font-bold text-[11px] leading-[17px] tracking-normal text-black opacity-100  break-all min-w-0">
                  + {addOn?.name ?? ""}
                </div>
                <div className="text-right font-bold text-[11px] leading-[17px] tracking-normal text-black opacity-100 whitespace-nowrap flex-shrink-0 pl-2">
                  {(item.quantity * addOn?.price).toFixed(2)} TK
                </div>
              </div>
            ))}

            {/*Addition Groups*/}
            <AdditionGroupsList additionGroups={Helper.transformAdditionGroups(item.additionGroups)} />
          </div>
        ))}

        {/* end item & prices */}

        <div className="w-full mt-[10px] border border-solid border-[#e5e7eb]"></div>

        {/* start sub total, discount, vat & service charge */}
        <div className="w-full h-[16px] flex flex-row items-center justify-between">
          <div className="w-[51px] h-full text-left font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557] opacity-100">
            Subtotal
          </div>

          <div className="w-auto h-full text-left font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557] opacity-100">
            {/* {orderDetails?.totalPriceBeforeDiscount.toFixed(2)} TK */}
            {orderDetails?.subTotal.toFixed(2)} TK
          </div>
        </div>

        {orderDetails?.discount > 0 && (
          <div className="w-full h-[16px] flex flex-row items-center justify-between">
            <div className="w-[120px] h-full text-left font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557] opacity-100">
              Discount {orderDetails.staffDiscount && <>({orderDetails.staffDiscount.discount}%)</>}
            </div>

            <div className="w-auto h-full text-left font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557] opacity-100">
              - {orderDetails?.discount.toFixed(2)} TK
            </div>
          </div>
        )}
        {orderDetails?.loyaltyDiscount && (
          <div className="w-full h-[16px] flex flex-row items-center justify-between">
            <div className="h-full text-left font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557] opacity-100">
              {orderDetails.loyaltyDiscount.discountType === "REDEEM" ? (
                <>Points Redeemed ({orderDetails.loyaltyDiscount.redeemedPoints.toFixed(2)})</>
              ) : (
                <>Loyalty Discount ({orderDetails.loyaltyDiscount.discountPercent.toFixed(2)}%)</>
              )}
            </div>

            <div className="w-auto h-full text-left font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557] opacity-100">
              - {orderDetails.loyaltyDiscount.discountAmount.toFixed(2)} TK
            </div>
          </div>
        )}
        
        {orderDetails?.couponDiscount && (
          <div className="w-full h-[16px] flex flex-row items-center justify-between">
            <div className="w-[220px] h-full text-left font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557] opacity-100">
              Coupon Discount {orderDetails.couponDiscount.isDiscountInPercent && <>({orderDetails.couponDiscount.discount}%)</>}
            </div>

            <div className="w-auto h-full text-left font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557] opacity-100">
              - {orderDetails?.couponDiscount.discountAmount.toFixed(2)} TK
            </div>
          </div>
        )}

        {orderDetails?.sd > 0 && !orderDetails?.isSupplementaryDutyIncluded && (
          <div className="w-full h-[16px] flex items-center">
            <div className="flex-1 text-left font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557]">
              Supplementary Duty
            </div>
            <div className="text-right font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557]">
              {(orderDetails?.sd ?? 0).toFixed(2)} TK
            </div>
          </div>
        )}

        {orderDetails?.serviceChargePercent > 0 && !orderDetails?.isServiceChargeIncluded && (
          <div className="w-full h-[16px] flex items-center">
            <div className="flex-1 text-left font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557]">
              Service charge ({(orderDetails?.serviceChargePercent ?? 0).toFixed(2)}%)
            </div>
            <div className="text-right font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557]">
              {(orderDetails?.serviceCharge ?? 0).toFixed(2)} TK
            </div>
          </div>
        )}

        {orderDetails?.vatPercent > 0 && !orderDetails?.isVatIncluded && (
          <div className="w-full h-[16px] flex flex-row items-center justify-between">
            <div className="flex-1 font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557]">
              VAT ({(orderDetails?.vatPercent ?? 0).toFixed(2)}%)
            </div>
            <div className="font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557] text-right">
              {(orderDetails?.vat ?? 0).toFixed(2)} TK
            </div>
          </div>
        )}

        {/* end sub total, discount, vat & service charge */}
        <div className="w-full mt-[10px] mb-[5px] border border-solid border-[#e5e7eb]"></div>

        {/* start of gross total */}
        <div className="w-full flex flex-row items-center justify-between">
          <div className="h-full text-left font-p_semibold text-[12px] tracking-normal text-[#341557] opacity-100">
            Gross Total
          </div>

          <div className="h-full text-left font-p_semibold text-[12px] tracking-normal text-[#341557] opacity-100">
            {orderDetails?.totalPriceBeforeRounding.toFixed(2)} TK
          </div>
        </div>
        {/* end of gross total */}

        <div className="w-full mt-[5px] mb-[5px] border border-solid border-[#e5e7eb]"></div>
        {(orderDetails?.isVatIncluded || orderDetails?.isSupplementaryDutyIncluded || orderDetails?.isServiceChargeIncluded) && (
          <div className=" mb-2">
            <div className=" h-[16px] font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557]">
              Included:
            </div>
            {orderDetails?.sd > 0 && orderDetails?.isSupplementaryDutyIncluded && (
              <div className="w-full h-[16px] flex items-center">
                <div className="flex-1 text-left font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557]">
                  Supplementary Duty 
                </div>
                <div className="text-right font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557]">
                  {(orderDetails?.sd ?? 0).toFixed(2)} TK
                </div>
              </div>
            )}
            {console.log('orderDetails?.isServiceChargeIncluded----------', {"orderDetails?.isServiceChargeIncluded": orderDetails?.isServiceChargeIncluded})}
            {orderDetails?.serviceChargePercent > 0 && orderDetails?.isServiceChargeIncluded && (
              <div className="w-full h-[16px] flex items-center">
                <div className="flex-1 text-left font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557]">
                  Service charge ({(orderDetails?.serviceChargePercent ?? 0).toFixed(2)}%)
                </div>
                <div className="text-right font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557]">
                  {(orderDetails?.serviceCharge ?? 0).toFixed(2)} TK
                </div>
              </div>
            )}
            {orderDetails?.isVatIncluded && orderDetails?.vatPercent > 0 && 
            <div className="w-full h-[16px] flex flex-row items-center justify-between">
              <div className="flex-1 font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557]">
                VAT ({(orderDetails?.vatPercent ?? 0).toFixed(2)}%)
              </div>
              <div className="font-p_regular text-[11px] leading-[17px] tracking-normal text-[#341557] text-right">
                {(orderDetails?.vat ?? 0).toFixed(2)} TK
              </div>
            </div>
            }
          </div>
        )}

        {orderDetails?.paymentStatus === 1 ? (
          <>
            {/* start payment section */}
            <div className="w-full h-[17px] flex flex-row items-center justify-between">
              <div className="w-[62px] h-full text-left font-p_semibold text-[12px] leading-[18px] tracking-normal text-[#341557] opacity-100">
                Payments
              </div>
            </div>

            <div className="w-full mt-[5px] mb-[10px] border border-solid border-[#e5e7eb]"></div>

            {orderDetails?.paymentReceiveTypes !== null && orderDetails?.paymentReceiveTypes.length > 0
              ? orderDetails?.paymentReceiveTypes.map((payment, index) => {
                  return (
                    <div className="w-full h-[17px] flex flex-row items-center justify-between" key={index + 2222}>
                      <div className="w-auto h-full text-left font-p_semibold text-[12px] leading-[18px] tracking-normal opacity-100 normal-case">
                        {payment.paymentReceiveType[0].toUpperCase() +
                          payment.paymentReceiveType.slice(1).toLowerCase()}
                      </div>

                      <div className="w-auto h-full text-left font-p_semibold text-[12px] leading-[18px] tracking-normal opacity-100">
                        {payment.amount.toFixed(2)} TK
                      </div>
                    </div>
                  );
                })
              : ""}

            {orderDetails?.paymentReceiveTypes !== null && orderDetails?.paymentReceiveTypes.length > 1 && (
              <div className="w-full h-[17px] flex flex-row items-center justify-between">
                <div className="h-full text-left font-p_semibold text-[12px] leading-[18px] tracking-normal opacity-100">
                  Total Paid
                </div>

                <div className="h-full text-left font-p_semibold text-[12px] leading-[18px] tracking-normal opacity-100">
                  {orderDetails?.totalPaidAmount.toFixed(2)} TK
                </div>
              </div>
            )}

            {orderDetails?.totalReturnAmount > 0 && (
              <div className="w-full h-[17px] flex flex-row items-center justify-between">
                <div className="w-[109px] h-full text-left font-p_semibold text-[12px] leading-[18px] tracking-normal opacity-100">
                  Returned Amount
                </div>

                <div className="w-auto h-full text-left font-p_semibold text-[12px] leading-[18px] tracking-normal text-[#341557] opacity-100">
                  {orderDetails?.totalReturnAmount > 0 ? "-" : ""} {orderDetails?.totalReturnAmount.toFixed(2)} TK
                </div>
              </div>
            )}

            {orderDetails.rounded !== 0 && (
              <div className="w-full h-[17px] flex flex-row items-center justify-between">
                <div className="w-[109px] h-full text-left font-p_semibold text-[12px] leading-[18px] tracking-normal opacity-100">
                  (+/-) Rounding
                </div>

                <div className="w-auto h-full text-left font-p_semibold text-[12px] leading-[18px] tracking-normal text-[#341557] opacity-100">
                  {orderDetails?.rounded.toFixed(2)} TK
                </div>
              </div>
            )}

            <div className="w-full mt-[10px] border border-solid border-[#e5e7eb]"></div>
          </>
        ) : (
          ""
        )}
        {/* end payment section */}

        {/* start thanks sections */}
        <div className="w-full mt-[5px] flex flex-row items-center justify-center">
          <div className="w-full h-full text-center font-semibold text-[16px] tracking-[0.64px] text-[#292929] opacity-100">
            Thank you for visiting!
          </div>
        </div>
        {/* end thanks sections */}

        <div className="w-full mt-[5px] border border-dashed border-[#e5e7eb]"></div>

        {/* start bill prepared sections */}
        {orderDetails?.staffName && (
          <div className="w-full h-[23px] mt-[5px] flex flex-row items-center justify-center">
            <div className="w-auto h-full text-left font-semibold text-[16px] leading-[35px] tracking-[0.64px] text-[#292929] opacity-100">
              Payment received by: {orderDetails?.staffName}
            </div>
          </div>
        )}
        {/* end prepared sections */}

        {/* start table tap website link & number*/}
        <div className="w-full h-[17px] mt-[20px] flex flex-row items-center justify-center">
          <div className="w-[272px] h-full text-center font-medium text-[12px] leading-[18px] tracking-[0.6px] text-[#000000] opacity-100">
            Powered by tabletap.xyz
          </div>
        </div>
      </div>
    </div>
  );
}
